<template>
  <div class="col-3 d-flex flex-column contact-list">
    <div class="search media">
      <div class="media-body">
        <search-input
          @search="searchContact"
          :placeholder="$t('label.search_contact')"
        ></search-input>
        <search-input
          @search="searchAddressNo"
          :placeholder="$t('label.search_home')"
        ></search-input>
      </div>
      <div class="ml-3">
        <filter-dropdown
          :header="'คัดกรองตามหมวดหมู่'"
          :rows="rows"
          :type="'radio'"
          @filterSubmit="filterContact"
        ></filter-dropdown>
      </div>
    </div>
    <ul class="topic-cases nav tabs">
      <li
        role="presentation"
        class="col tab"
        :class="{ active: tabListOpen }"
        data-toggle="tab"
        @click="activeTab('open')"
      >
        ยังไม่ได้ปิด
      </li>
      <li
        role="presentation"
        class="col tab"
        :class="{ active: tabListClose }"
        data-toggle="tab"
        @click="activeTab('close')"
      >
        ปิดแล้ว
      </li>
    </ul>
    <div class="col p-0 contact-list">
      <contact-navigation
        class="list-unstyled"
        :contacts="contacts"
      ></contact-navigation>
      <infinite-loading
        @infinite="infiniteHandler"
        spinner="spiral"
        ref="infiniteLoading"
      >
        <span slot="no-results" />
        <span slot="no-more" />
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import { getCookie, Auth } from "@/lib/cookie";

import ContactNavigation from "@/components/admin/view/contact/ContactNavigation";
import SearchInput from "@/components/helper/SearchInput";
import FilterDropdown from "@/components/helper/Dropdown";

export default {
  props: ["selectedTab"],
  components: {
    ContactNavigation,
    InfiniteLoading,
    SearchInput,
    FilterDropdown
  },
  data() {
    return {
      contacts: {},
      contactsOpen: {},
      contactsClose: {},
      contactId: this.$route.params.contactId,
      tabListOpen: true,
      tabListClose: false,
      filterCategory: "",
      filterStatus: "IN_PROGRESS",
      filterText: "",
      filterAddressNo: "",
      page: 1,
      limit: 15,
      rows: [
        {
          key: "",
          value: "ทุกหมวดหมู่"
        },
        {
          key: "CONTACT",
          value: "พูดคุยสอบถาม"
        },
        {
          key: "COMMENT",
          value: "แนะนำ/ติชม"
        },
        {
          key: "COMPLAINT",
          value: "ร้องเรียน"
        },
        {
          key: "GREETING",
          value: "ทักทาย"
        },
        {
          key: "ONLINE_REPAIR",
          value: "แจ้งซ่อมออนไลน์"
        },
        {
          key: "REPORT_HOME_AUTOMATION_PROBLEM",
          value: "แจ้งปัญหา Home Automation"
        }
      ],
      isReply: this.$route.query.reply
    };
  },
  watch: {
    selectedTab(val) {
      this.activeTab(val);
    },
    $route(to) {
      if (to.params.contactId) {
        this.contactId = to.params.contactId;
        this.isReply = to.query.reply;
        this.setUnread(to.params.contactId);
      }
    },
    projectId() {
      this.resetLoading();
    }
  },
  mounted() {
    this.filterContact();

    if (this.$messaging) {
      this.$messaging.onMessage(payload => {
        const vm = this;

        if (
          payload.data.targetFeature === "CONVERSATION" &&
          (this.projectId === "OTHER" ||
            this.projectId === payload.data.projectId) &&
          payload.data.targetAction === "CREATE"
        ) {
          const newContact = {
            contactCategory: {
              title: payload.data.categoryName
            },
            contactCategoryId: payload.data.categoryId,
            topic: {
              createdAt: new Date(),
              createdByUser: {
                firstName: payload.data.userFirstName,
                lastName: payload.data.userLastName
              },
              detail: payload.notification.body,
              topicId: payload.data.targetId,
              unreadCount: 1
            }
          };

          this.contacts.unshift(newContact);
        } else if (
          payload.data.targetFeature === "CONVERSATION" &&
          (this.projectId === "OTHER" ||
            this.projectId === payload.data.projectId) &&
          payload.data.targetAction === "REPLY"
        ) {
          this.contacts.forEach(element => {
            if (
              element.topic.topicId.toString() === payload.data.targetId &&
              vm.contactId.toString() !== payload.data.targetId
            ) {
              element.topic.unreadCount += 1;
            } else {
              element.topic.unreadCount = 0;
            }
          });
        }
      });
    } else {
      console.debug("Could not init push notification listener");
    }
  },
  computed: {
    projectId() {
      return this.$store.state.projectId;
    },
    projectName() {
      return this.$store.state.projectName;
    }
  },
  methods: {
    infiniteHandler($state) {
      this.page += 1;

      this.getContact(
        this.filterText,
        this.filterAddressNo,
        this.filterStatus,
        this.filterCategory,
        this.page,
        this.limit,
        $state
      );
    },
    resetLoading() {
      this.contacts = [];
      this.page = 0;
      this.$nextTick(() => {
        this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
      });
    },
    activeTab(tab) {
      if (tab === "close") {
        this.tabListOpen = false;
        this.tabListClose = true;
        this.filterStatus = "CLOSED";
      } else {
        this.tabListOpen = true;
        this.tabListClose = false;
        this.filterStatus = "IN_PROGRESS";
      }

      this.filterContact(this.filterCategory);
    },
    filterContact(category) {
      this.filterCategory = category;
      this.resetLoading();
    },
    searchContact(searchtext) {
      this.filterText = searchtext;
      this.resetLoading();
    },
    searchAddressNo(addressNo) {
      this.filterAddressNo = addressNo;
      this.resetLoading();
    },
    async getContact(
      searchText = "",
      addressNo = "",
      status,
      filter,
      page = 1,
      limit = 15,
      $state = undefined
    ) {
      try {
        const res = await axios.get(
          `${process.env.HOST}/admin/conversations/projects/${this.projectId}`,
          {
            headers: {
              Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
            },
            params: { page, limit, searchText, addressNo, filter, status }
          }
        );

        if (res.data.rows.length) {
          const contactList = Object.assign(res.data);

          this.contacts = this.checkDupicate(
            this.contacts.concat(contactList.rows)
          );
          // this.setUnread(this.contactId);
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (error) {
        $state.complete();

        throw error;
      }
    },
    checkDupicate(source) {
      return [...new Set(source)];
    },
    setUnread(contactId, countUnread = 0) {
      if (contactId !== "all" && this.isReply === "successful") {
        this.contacts.forEach(element => {
          if (element.topic.topicId === parseInt(contactId)) {
            element.topic.unreadCount = countUnread;
          }
        });

        this.$router.push({
          name: "Contact",
          params: { contactId: this.contactId }
        });
      }
    }
  }
};
</script>

<style scoped>
.topic-cases {
  height: 54px;
  padding-top: 15px;
  border-bottom: 1px solid #e0e0e0;
}
.tab {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: -0.1px;
  color: #8c8786;
  cursor: pointer;
}
.tab.active {
  color: #e27024;
  font-weight: bold;
  border-bottom: 2px solid #e27024;
}
.contact-list {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/contact/ContactList.vue